import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hotel-spinner',
  templateUrl: './hotel-spinner.component.html',
  styleUrls: ['./hotel-spinner.component.scss']
})
export class HotelSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
